import React from "react";

export default function PrivacyPage() {
  return (
    <div style={{ fontFamily: "'DM Sans', 'Segoe UI', system-ui, sans-serif", color: "#1a1a1a", background: "#fafaf8", minHeight: "100vh", padding: "24px 16px 48px" }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Serif+Display&display=swap" rel="stylesheet" />
      <div style={{ maxWidth: 720, margin: "0 auto" }}>
        <a href="/" style={{ display: "inline-flex", alignItems: "center", gap: 6, color: "#2d5a27", fontWeight: 600, fontSize: 14, textDecoration: "none", marginBottom: 32 }}>
          ← Back to home
        </a>
        <h1 style={{ fontSize: 32, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: "0 0 8px", color: "#1a1f16" }}>Privacy Policy</h1>
        <p style={{ fontSize: 14, color: "#6b7280", margin: "0 0 32px" }}>Last updated: {new Date().toLocaleDateString("en-US")}</p>

        <section style={{ marginBottom: 28 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 12px", color: "#1a1f16" }}>1. Introduction</h2>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: "#374151", margin: 0 }}>
            Ingrediable (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;) operates the Ingrediable app and related services. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our service.
          </p>
        </section>

        <section style={{ marginBottom: 28 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 12px", color: "#1a1f16" }}>2. Information We Collect</h2>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: "#374151", margin: "0 0 12px" }}>
            We collect information you provide directly (e.g., when you create an account or add items to your kitchen):
          </p>
          <ul style={{ margin: "0 0 12px", paddingLeft: 24, fontSize: 15, lineHeight: 1.7, color: "#374151" }}>
            <li><strong>Account data:</strong> email address, display name, and password (stored securely).</li>
            <li><strong>Kitchen data:</strong> inventory items, shopping lists, expiry dates, waste logs, and household names you enter.</li>
            <li><strong>Usage data:</strong> how you use the app (e.g., features used) to improve the product.</li>
          </ul>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: "#374151", margin: 0 }}>
            We use Supabase for authentication and database storage and Resend for transactional emails (e.g., password reset, confirmation). These providers process data in accordance with their privacy policies and our instructions.
          </p>
        </section>

        <section style={{ marginBottom: 28 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 12px", color: "#1a1f16" }}>3. How We Use Your Information</h2>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: "#374151", margin: 0 }}>
            We use your information to provide, maintain, and improve Ingrediable; to send you service-related emails (e.g., expiry alerts if you opt in); to respond to your requests; and to comply with legal obligations. We do not sell your personal information.
          </p>
        </section>

        <section style={{ marginBottom: 28 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 12px", color: "#1a1f16" }}>4. Sharing and Disclosure</h2>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: "#374151", margin: 0 }}>
            We may share data with service providers (hosting, email, analytics) who assist in operating our service. Household members you invite can see shared kitchen data (inventory, shopping list) for that household. We may disclose information if required by law or to protect our rights and safety.
          </p>
        </section>

        <section style={{ marginBottom: 28 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 12px", color: "#1a1f16" }}>5. Data Retention and Security</h2>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: "#374151", margin: 0 }}>
            We retain your data for as long as your account is active or as needed to provide the service and comply with law. We use industry-standard measures to protect your data; no method of transmission over the internet is 100% secure.
          </p>
        </section>

        <section style={{ marginBottom: 28 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 12px", color: "#1a1f16" }}>6. Your Rights</h2>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: "#374151", margin: 0 }}>
            Depending on your location, you may have the right to access, correct, delete, or export your personal data, or to object to or restrict certain processing. You can update account and notification settings in the app. To exercise other rights or ask questions, contact us at the email below.
          </p>
        </section>

        <section style={{ marginBottom: 28 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 12px", color: "#1a1f16" }}>7. Contact</h2>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: "#374151", margin: 0 }}>
            For privacy-related questions or requests, contact us at <a href="mailto:privacy@ingrediable.com" style={{ color: "#2d5a27", fontWeight: 600 }}>privacy@ingrediable.com</a>.
          </p>
        </section>
      </div>
    </div>
  );
}
